import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=b92a845a&scoped=true"
import script from "./ArticlePreview.vue?vue&type=script&lang=js"
export * from "./ArticlePreview.vue?vue&type=script&lang=js"
import style0 from "./ArticlePreview.vue?vue&type=style&index=0&id=b92a845a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92a845a",
  null
  
)

export default component.exports